export default {
  FETCH_OWNER_VALIDATION_METHOD_REQUEST: 'FETCH_OWNER_VALIDATION_METHOD_REQUEST',
  FETCH_OWNER_VALIDATION_METHOD_SUCCESS: 'FETCH_OWNER_VALIDATION_METHOD_SUCCESS',
  FETCH_OWNER_VALIDATION_METHOD_FAILURE: 'FETCH_OWNER_VALIDATION_METHOD_FAILURE',

  VALIDATE_OWNER_DATA_REQUEST: 'VALIDATE_OWNER_DATA_REQUEST',
  VALIDATE_OWNER_DATA_SUCCESS: 'VALIDATE_OWNER_DATA_SUCCESS',
  VALIDATE_OWNER_DATA_FAILURE: 'VALIDATE_OWNER_DATA_FAILURE',

  REGISTRATION_FETCH_RETAILER_DETAILS_REQUEST: 'REGISTRATION_FETCH_RETAILER_DETAILS_REQUEST',
  REGISTRATION_FETCH_RETAILER_DETAILS_SUCCESS: 'REGISTRATION_FETCH_RETAILER_DETAILS_SUCCESS',
  REGISTRATION_FETCH_RETAILER_DETAILS_FAILURE: 'REGISTRATION_FETCH_RETAILER_DETAILS_FAILURE',

  REGISTRATION_UPDATE_RETAILER_DETAILS: 'REGISTRATION_UPDATE_RETAILER_DETAILS',
  REGISTRATION_CLEAR_RETAILER_DETAILS: 'REGISTRATION_CLEAR_RETAILER_DETAILS',

  CREATE_ACCOUNT_REQUEST: 'CREATE_ACCOUNT_REQUEST',
  CREATE_ACCOUNT_SUCCESS: 'CREATE_ACCOUNT_SUCCESS',
  CREATE_ACCOUNT_FAILURE: 'CREATE_ACCOUNT_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/registration/actions/action-types.js